import { render, staticRenderFns } from "./TableConfigColumnSort.vue?vue&type=template&id=573a567f&"
import script from "./TableConfigColumnSort.vue?vue&type=script&lang=js&"
export * from "./TableConfigColumnSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports